import { fmtPrice, useT } from '@repo/common';

const SummaryRow = ({ label, value, strong }) => (
  <div className='flex items-center gap-2'>
    <span
      className={
        strong ? 'typo-b16 text-text-primary' : 'typo-b14 text-text-placeholder'
      }
    >
      {label}
    </span>
    <span
      className={
        strong
          ? 'typo-b16Strong text-text-primary'
          : 'typo-b14Strong text-text-primary'
      }
    >
      {value}
    </span>
  </div>
);

const RefundSummary = ({
  selectedItemTotal,
  cancellationFee,
  estimatedRefund,
  currency,
}) => {
  const t = useT();

  return (
    <div className='flex flex-col items-end gap-2 py-4'>
      <SummaryRow
        label={t('Selected Item Total:', '선택 상품 합계:')}
        value={fmtPrice(selectedItemTotal, currency)}
      />
      <SummaryRow
        label={t('Cancellation Fee:', '취소 수수료:')}
        value={`- ${fmtPrice(cancellationFee, currency)}`}
      />
      <SummaryRow
        label={t('Estimated Refund:', '예상 환불 금액:')}
        value={fmtPrice(estimatedRefund, currency)}
        strong
      />
    </div>
  );
};

export default RefundSummary;
